"use client";

import OsmBanner from "@/components/osm-banner.js";
import NavigationCenter from "@/components/navigation-center.js";
import Media54 from "@/components/media-5-4.js";
import SpacingMedium from "@/components/spacing-medium.js";
import Media169 from "@/components/media-16-9.js";
import HeaderSection from "@/components/header-section.js";
import Media219 from "@/components/media-21-9.js";
import HeaderTnc from "@/components/header-tnc.js";
import TestimonyPortrait from "@/components/testimony-portrait.js";
import SpacingLarge from "@/components/spacing-large.js";
import FooterOmnichannel from "@/components/footer-omnichannel.js";
import FullBody from "@/components/full-body.js";
import StickyManager from "@/utils/sticky-manager";
import Notification from "@/components/notification";


export default function ExportedPage() {
  return (
    <main style={{ position: 'relative', minHeight: '100vh', width: '100%', overflowX: 'clip', containerType: 'inline-size', containerName: 'root-container' }}>
      <div id="canvas-background-root" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 0, pointerEvents: 'none', overflow: 'hidden' }} />
      <div style={{ position: 'relative', zIndex: 1, width: '100%' }}>
      <StickyManager stickyIndices={[0,1]} stackedIndices={[]} blurIndices={[]} overlayIndices={[]} transparentNextIndices={[]}>
      <OsmBanner
        title={"Waspada penipuan! Pemenang tidak dipungut biaya apa pun dan hanya akan dihubungi melalui <b>WhatsApp Resmi <a href=\"https://api.whatsapp.com/send?phone=6281119751441&text=Halo%20MinYes%2C%20saya%20ingin%20klaim%20hadiah%20Ramen%20YES%2C%20mohon%20bantuannya%20ya\">0811-1975-1441</a>&nbsp;</b>atau <b>WINGS Customer Care +62 21 50957907</b>."}
        buttonText={"Label"}
        buttonUrl={""}
        buttonVisible={false}
        buttonLinkType={"url"}
        buttonTargetDialogId={""}
        buttonId={""}
        buttonSvgPath={""}
        buttonSvgViewBox={""}
        buttonSvgStrokeWidth={""}
        variant={"brand"}
        sectionId={"section-osm"}
      />
      <NavigationCenter
        logo={"https://assets.ramenyes.com/logo_ramen_yes.webp"}
        logoId={"section-navigation--logo"}
        logoUrl={""}
        logoOpenInNewTab={false}
        logoLinkType={"url"}
        logoTargetDialogId={""}
        menu1Label={"Hadiah"}
        menu1Url={"#section-hadiah"}
        menu1LinkType={"url"}
        menu1TargetDialogId={""}
        menu1Id={"section-navigation--menu-1"}
        menu2Label={"Panduan"}
        menu2Url={"#section-panduan"}
        menu2LinkType={"url"}
        menu2TargetDialogId={""}
        menu2Id={"section-navigation--menu-2"}
        menu3Label={"Ketentuan"}
        menu3Url={"#header-section-syarat-dan-ketentuan"}
        menu3LinkType={"url"}
        menu3TargetDialogId={""}
        menu3Id={"section-navigation--menu-3"}
        menu4Label={"Pemenang"}
        menu4Url={"#section-pemenang"}
        menu4LinkType={"url"}
        menu4TargetDialogId={""}
        menu4Id={"section-navigation--menu-4"}
        menuColor={"default"}
        navBackground={"transparent"}
        sectionId={"section-navigation"}
      />
      <Media54
        image={"https://assets.ramenyes.com/headline_final.webp"}
        imageUrl={""}
        imageLinkType={"url"}
        imageTargetDialogId={""}
        fullWidth={false}
        imageIsPortrait={false}
        imageMobileRatio={""}
        imageMobileSrc={""}
        imageAutoplay
        sectionId={"section-hadiah"}
        imageShowStroke={"https://space.lunaaar.site/assets-lunar/placeholder.svg"}
      />
      <SpacingMedium
        sectionId={"spacing"}
      />
      <Media169
        image={"https://assets.ramenyes.com/TVC%20Ramen%20YES.webm"}
        imageUrl={""}
        imageLinkType={"url"}
        imageTargetDialogId={""}
        fullWidth={false}
        imageIsPortrait={false}
        imageMobileRatio={""}
        imageMobileSrc={""}
        imageAutoplay
        sectionId={"section-tvc"}
      />
      <SpacingMedium
        sectionId={"spacing"}
      />
      <HeaderSection
        title={"Mudah Banget Ikutnya!"}
        subtitle={"Lorem Ipsum is simply dummy text of the printing and typesetting industry"}
        titleTypography={"h2"}
        subtitleTypography={"subheader-h1"}
        subtitleVisible={false}
        buttonStyle={"primary"}
        buttonText={"Label"}
        buttonUrl={""}
        buttonVisible={false}
        buttonLinkType={"url"}
        buttonTargetDialogId={""}
        buttonId={"section-panduan--button"}
        buttonSvgPath={""}
        buttonSvgViewBox={""}
        buttonSvgStrokeWidth={""}
        secondaryButtonText={"Label"}
        secondaryButtonUrl={""}
        secondaryButtonVisible={false}
        secondaryButtonLinkType={"url"}
        secondaryButtonTargetDialogId={""}
        secondaryButtonId={"section-panduan--secondary-button"}
        secondaryButtonSvgPath={""}
        secondaryButtonSvgViewBox={""}
        secondaryButtonSvgStrokeWidth={""}
        sectionId={"section-panduan"}
        titleId={"section-panduan--title"}
        subtitleId={"section-panduan--subtitle"}
      />
      <Media219
        image={"https://assets.ramenyes.com/guidance.webp"}
        imageUrl={""}
        imageLinkType={"url"}
        imageTargetDialogId={""}
        fullWidth={false}
        imageIsPortrait={false}
        imageMobileRatio={""}
        imageMobileSrc={""}
        imageAutoplay
        sectionId={"section-foto-panduan"}
        imageId={"section-foto-panduan--image"}
      />
      <SpacingMedium
        sectionId={"spacing"}
      />
      <HeaderSection
        title={"Yuk, Ambil Hadiahmu!"}
        subtitle={"Ikuti panduan, lakukan klaim, dan pahami syarat & ketentuan untuk mendapatkan hadiahmu."}
        titleTypography={"h2"}
        subtitleTypography={"subheader-h1"}
        buttonStyle={"primary"}
        buttonText={"Klaim Hadiah"}
        buttonUrl={"https://api.whatsapp.com/send?phone=6281119751441&text=Halo%20MinYes%2C%20saya%20ingin%20klaim%20hadiah%20Ramen%20YES%2C%20mohon%20bantuannya%20ya"}
        buttonLinkType={"url"}
        buttonTargetDialogId={""}
        buttonId={""}
        buttonSvgPath={""}
        buttonSvgViewBox={""}
        buttonSvgStrokeWidth={""}
        secondaryButtonText={"Label"}
        secondaryButtonUrl={"https://api.whatsapp.com/send?phone=6281119751441&text=Halo%20MinYes%2C%20saya%20ingin%20klaim%20hadiah%20Ramen%20YES%2C%20mohon%20bantuannya%20ya"}
        secondaryButtonVisible={false}
        secondaryButtonLinkType={"url"}
        secondaryButtonTargetDialogId={""}
        secondaryButtonId={""}
        secondaryButtonSvgPath={""}
        secondaryButtonSvgViewBox={""}
        secondaryButtonSvgStrokeWidth={""}
        sectionId={"header-section-syarat-dan-ketentuan"}
      />
      <SpacingMedium
        sectionId={"spacing"}
      />
      <HeaderTnc
        hasCardStyle
        items={[{"title":"Syarat dan Ketentuan","description":"<div><b>Periode Promo: Juni 2026 – Desember 2026&nbsp; •&nbsp;&nbsp;<span style=\"background-color: initial;\">Batas Penukaran Hadiah: 31 Januari 2027</span></b></div><div><b><span style=\"background-color: initial;\"><br></span></b></div><ol><li>Temukan stiker hologram pada box kemasan yang bertanda khusus.</li><li>Periksa bagian dalam inner box isi 12 pcs dan gosok stiker hologram untuk mengetahui hadiah yang Anda dapatkan.</li><li>Lepaskan stiker hologram secara perlahan dari inner box dan pastikan stiker tidak rusak atau robek. Simpan stiker hologram sebagai bukti untuk proses penukaran hadiah.</li><li>Penyelenggara tidak bertanggung jawab atas kerusakan stiker hologram sebelum proses penukaran hadiah dilakukan.</li><li>Program ini tidak berlaku bagi karyawan WINGS beserta anggota keluarganya.</li><li>Ramen YES tidak pernah memungut biaya apa pun dari pemenang program yang diselenggarakan oleh Ramen YES.</li><li>Pemenang tidak dipungut biaya apapun. Waspadai penipuan yang mengatasnamakan Ramen YES. Informasi resmi hanya disampaikan melalui WhatsApp Hotline <a href=\"https://api.whatsapp.com/send?phone=6281119751441&text=Halo%20MinYes%2C%20saya%20ingin%20klaim%20hadiah%20Ramen%20YES%2C%20mohon%20bantuannya%20ya\">0811-1975-1441</a>. Segala komunikasi di luar nomor tersebut bukan merupakan tanggung jawab Ramen YES.<br></li></ol>","titleVisible":true,"descriptionVisible":true,"titleId":"section-detail-ketentuan-title-syaratketentuan","descriptionId":"section-detail-ketentuan-desc-syaratketentuan","cardId":"tnc-card-0","visible":true},{"title":"Cara Penukaran Hadiah","description":"<ol><li><span style=\"color: var(--content-neutral--body);\">Langkah Penukaran Hadiah untuk Para Pemenang</span><ol type=\"a\"><li>Hadiah produk dan uang tunai<br>Pemenang dapat menukarkan stiker hologram di toko terdekat yang menjual produk Ramen YES dan berpartisipasi dalam program ini.</li><li>Hadiah selain produk dan uang tunai (mobil, TV, handphone, sepeda listrik, dan emas)<ul><li>Pemenang perlu mengirimkan foto stiker hologram yang memuat kode unik ke WhatsApp Hotline <u><a href=\"https://api.whatsapp.com/send?phone=6281119751441&text=Halo%20MinYes%2C%20saya%20ingin%20klaim%20hadiah%20Ramen%20YES%2C%20mohon%20bantuannya%20ya\">0811-1975-1441</a></u>.</li><li>Penyelenggara akan melakukan verifikasi terhadap keabsahan kode unik tersebut. Hadiah hanya akan diberikan apabila kode dinyatakan sah dan valid oleh penyelenggara.</li></ul></li></ol></li><li>Pemenang tidak dapat menukar hadiah dengan bentuk lain<br>Seluruh hadiah diberikan sesuai ketersediaan stok. Apabila hadiah tertentu tidak tersedia, penyelenggara berhak menggantinya dengan hadiah lain yang memiliki nilai setara tanpa pemberitahuan sebelumnya. Penyelenggara tidak berkewajiban menyediakan hadiah yang telah habis atau tidak tersedia pada saat proses penyerahan hadiah dilakukan.</li><li>Pemenang wajib memeriksa kondisi hadiah maksimal 1 x 24 jam setelah hadiah diterima<br>Setelah melewati batas waktu tersebut, penyelenggara tidak bertanggung jawab atas segala bentuk keluhan atau komplain terkait kondisi hadiah.</li><li>Dengan menukarkan hadiah, pemenang dianggap telah:<ul><li>Membaca, memahami, dan menyetujui seluruh syarat dan ketentuan program.</li><li>Bersedia memberikan data pribadi yang diperlukan untuk keperluan administrasi program.</li><li>Memberikan izin kepada penyelenggara untuk menggunakan nama, foto, dan/atau dokumentasi pemenang untuk kebutuhan publikasi dan promosi tanpa kompensasi tambahan.</li></ul></li><li>Seluruh pajak hadiah akan ditanggung oleh penyelenggara.<br>Untuk informasi lebih lanjut, hubungi Hotline <a href=\"https://api.whatsapp.com/send?phone=6281119751441&text=Halo%20MinYes%2C%20saya%20ingin%20klaim%20hadiah%20Ramen%20YES%2C%20mohon%20bantuannya%20ya\">0811-1975-1441</a> atau kunjungi <a href=\"http://www.ramenyes.com/\">ramenyes.com</a>.<br></li></ol>","titleVisible":true,"descriptionVisible":true,"visible":true,"cardId":"tnc-item-1","titleId":"section-detail-ketentuan-title-carapenukaran","descriptionId":"section-detail-ketentuan-desc-carapenukaran"},{"title":"Title","description":"Lorem Ipsum is simply dummy text of the printing and typesetting industry","titleVisible":true,"descriptionVisible":true,"visible":false,"cardId":"tnc-item-2"}]}
        sectionId={"section-detail-ketentuan"}
      />
      <SpacingMedium
        sectionId={"spacing"}
      />
      <HeaderSection
        title={"Daftar Pemenang Beruntung"}
        subtitle={"Lorem Ipsum is simply dummy text of the printing and typesetting industry"}
        titleTypography={"h2"}
        subtitleTypography={"subheader-h1"}
        subtitleVisible={false}
        buttonStyle={"primary"}
        buttonText={"Label"}
        buttonUrl={""}
        buttonVisible={false}
        buttonLinkType={"url"}
        buttonTargetDialogId={""}
        buttonId={""}
        buttonSvgPath={""}
        buttonSvgViewBox={""}
        buttonSvgStrokeWidth={""}
        secondaryButtonText={"Label"}
        secondaryButtonUrl={""}
        secondaryButtonVisible={false}
        secondaryButtonLinkType={"url"}
        secondaryButtonTargetDialogId={""}
        secondaryButtonId={""}
        secondaryButtonSvgPath={""}
        secondaryButtonSvgViewBox={""}
        secondaryButtonSvgStrokeWidth={""}
        sectionId={"section-pemenang"}
        titleId={"section-pemenang--title"}
      />
      <TestimonyPortrait
        testimonies={[{"name":"YULIANTI","role":"<b>Emas&nbsp;</b>• Jember","description":"Terima kasih Ramen YES untuk hadiah emasnya!","image":"https://space.lunaaar.site/assets-ramenyes/winner_emas_new_ratio.webp","imageUrl":"","imageLinkType":"url","imageTargetDialogId":"","avatar":"https://space.lunaaar.site/assets-ramenyes/emas_1gr.webp","avatarUrl":"","avatarLinkType":"url","avatarTargetDialogId":"","imageVisible":true,"avatarVisible":true,"imageAutoplay":true,"avatarAutoplay":true,"cardId":"","visible":true},{"name":"SUHAENI","role":"<b>Smart TV</b> • Jember","description":"Senang bisa menang Smart TV dari Ramen YES. Terima kasih!","image":"https://space.lunaaar.site/assets-ramenyes/winner_tv_new_ratio.webp","imageUrl":"","imageLinkType":"url","imageTargetDialogId":"","avatar":"https://space.lunaaar.site/assets-ramenyes/televisi.webp","avatarUrl":"","avatarLinkType":"url","avatarTargetDialogId":"","imageVisible":true,"avatarVisible":true,"imageAutoplay":true,"avatarAutoplay":true,"cardId":"","visible":true},{"name":"JENY P. SIMANGUNSONG","role":"<b>Emas</b> • Batam","description":"Terima kasih Ramen YES, senang banget bisa menang emas!","image":"https://space.lunaaar.site/assets-ramenyes/jeny_parluhutan_simangunsong_-_emas.webp","imageUrl":"","imageLinkType":"url","imageTargetDialogId":"","avatar":"https://space.lunaaar.site/assets-ramenyes/emas_1gr.webp","avatarUrl":"","avatarLinkType":"url","avatarTargetDialogId":"","imageVisible":true,"avatarVisible":true,"imageAutoplay":true,"avatarAutoplay":true,"cardId":"","visible":true},{"name":"SAMRIAH","role":"<b>Emas</b> • Leuwiliang","description":"Nggak nyangka bisa dapat hadiah emas dari Ramen YES!","image":"https://space.lunaaar.site/assets-ramenyes/samriah.webp","imageUrl":"","imageLinkType":"url","imageTargetDialogId":"","avatar":"https://space.lunaaar.site/assets-ramenyes/emas_1gr.webp","avatarUrl":"","avatarLinkType":"url","avatarTargetDialogId":"","imageVisible":true,"avatarVisible":true,"imageAutoplay":true,"avatarAutoplay":true,"cardId":"","visible":true},{"name":"NUR AFNI","role":"<b>Emas</b> • Jonggol","description":"Terima kasih Ramen YES, hadiahnya jadi rezeki tak terduga!","avatar":"https://space.lunaaar.site/assets-ramenyes/emas_1gr.webp","avatarVisible":true,"image":"https://space.lunaaar.site/assets-ramenyes/nur_afni.webp","imageVisible":true,"visible":true,"cardId":"testimony-4"},{"name":"PURWANTI","role":"<b>Emas</b>&nbsp;• Depok","description":"Senang sekali bisa jadi pemenang hadiah emas Ramen YES!","avatar":"https://space.lunaaar.site/assets-ramenyes/emas_1gr.webp","avatarVisible":true,"image":"https://space.lunaaar.site/assets-ramenyes/purwanti.webp","imageVisible":true,"visible":true,"cardId":"testimony-5"},{"name":"RUDIYANTO","role":"<b>Emas</b> • Soreang","description":"Terima kasih Ramen YES atas hadiah emas yang spesial!","avatar":"https://space.lunaaar.site/assets-ramenyes/emas_1gr.webp","avatarVisible":true,"image":"https://space.lunaaar.site/assets-ramenyes/rudiyanto.webp","imageVisible":true,"visible":true,"cardId":"testimony-6"},{"name":"TANINGKEM","role":"<b>Emas</b> • Jonggol","description":"Bahagia banget dapat emas dari Ramen YES, terima kasih!","avatar":"https://space.lunaaar.site/assets-ramenyes/emas_1gr.webp","avatarVisible":true,"image":"https://space.lunaaar.site/assets-ramenyes/taningkem.webp","imageVisible":true,"visible":true,"cardId":"testimony-7"}]}
        fullWidth
        autoScroll
        autoScrollEffect={"marquee"}
        marqueeDuration={48}
        marqueeDirection={"rtl"}
        imageShowStroke={false}
        sectionId={"section-foto-pemenang"}
      />
      <SpacingMedium
        sectionId={"spacing"}
      />
      <HeaderSection
        title={"Varian Produk"}
        subtitle={"Nikmati pilihan rasa&nbsp;<span style=\"background-color: transparent;\">dari</span><div><b style=\"background-color: transparent;\"><span style=\"color: var(--content-brand--brand);\">Hakata Chicken Ramen</span></b><span style=\"background-color: transparent;\"> dan </span><b style=\"background-color: transparent;\"><span style=\"color: var(--content-brand--brand);\">Tokyo Chicken Yakitori</span></b><span style=\"background-color: transparent;\">.</span></div>"}
        titleTypography={"h2"}
        subtitleTypography={"subheader-h1"}
        subtitleVisible
        buttonStyle={"primary"}
        buttonText={"Beli Sekarang"}
        buttonUrl={"#https://s.shopee.co.id/gNOKda0aV"}
        buttonVisible={false}
        buttonLinkType={"url"}
        buttonTargetDialogId={""}
        buttonId={"section-produk--button"}
        buttonSvgPath={""}
        buttonSvgViewBox={""}
        buttonSvgStrokeWidth={""}
        secondaryButtonText={"Label"}
        secondaryButtonUrl={""}
        secondaryButtonVisible={false}
        secondaryButtonLinkType={"url"}
        secondaryButtonTargetDialogId={""}
        secondaryButtonId={"section-produk--secondary-button"}
        secondaryButtonSvgPath={""}
        secondaryButtonSvgViewBox={""}
        secondaryButtonSvgStrokeWidth={""}
        sectionId={"section-produk"}
        titleId={"section-produk--title"}
        subtitleId={"section-produk--subtitle"}
      />
      <Media219
        image={"https://assets.ramenyes.com/list_product.webp"}
        imageUrl={""}
        imageLinkType={"url"}
        imageTargetDialogId={""}
        fullWidth={false}
        imageIsPortrait={false}
        imageMobileRatio={""}
        imageMobileSrc={""}
        imageAutoplay
        sectionId={"section-list-produk"}
        imageId={"section-list-produk--image"}
      />
      <SpacingMedium
        sectionId={"spacing"}
      />
      <Media219
        image={"https://assets.ramenyes.com/product.webp"}
        imageUrl={""}
        imageLinkType={"url"}
        imageTargetDialogId={""}
        fullWidth={false}
        imageIsPortrait={false}
        imageMobileRatio={""}
        imageMobileSrc={""}
        imageAutoplay
        sectionId={"section-foto-produk"}
        imageId={"section-foto-produk--image"}
      />
      <SpacingLarge
        sectionId={"spacing"}
      />
      <FooterOmnichannel
        image={"https://assets.ramenyes.com/logo_footer.webp"}
        menuColor={"default"}
        copyrightText={"<span style=\"color: var(--content-neutral--body);\">Copyright © Ramen YES 2026</span>"}
        availableAtTitle={"Temui Kami di Sini"}
        resourcesTitle={"<br>"}
        socialLinks={[{"label":"@RamenYesOfficial","url":"https://www.youtube.com/@RamenYesOfficial","visible":true,"id":"","image":"https://assets.ramenyes.com/youtube.webp","imageId":"","linkType":"url","targetDialogId":""},{"label":"@RamenYess","url":"https://www.facebook.com/profile.php?id=61587449313136&mibextid=wwXIfr","visible":true,"id":"","image":"https://assets.ramenyes.com/facebook.webp","imageId":"","linkType":"url","targetDialogId":""},{"label":"[social-link]","url":"","visible":false,"id":"","image":"https://space.lunaaar.site/assets-lunar/placeholder.svg","imageId":"","linkType":"url","targetDialogId":""}]}
        findUsOnLinks={[{"label":"@ramenyes","url":"https://www.instagram.com/ramenyes/","visible":true,"id":"","image":"https://assets.ramenyes.com/instagram.webp","imageId":"","linkType":"url","targetDialogId":""},{"label":"@ramenyesofficial","url":"https://www.tiktok.com/@ramenyesofficial","visible":true,"id":"","image":"https://assets.ramenyes.com/tiktok.webp","imageId":"","linkType":"url","targetDialogId":""},{"label":"@RamenYesID&nbsp;","url":"https://x.com/ramenyesid","visible":true,"id":"","image":"https://assets.ramenyes.com/x.webp","imageId":"","linkType":"url","targetDialogId":""}]}
        resourceLinks={[{"label":"&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;","url":"","visible":true,"id":"","linkType":"url","targetDialogId":""},{"label":"Privacy Policy","url":"https://wingscorp.com/kebijakan-privasi/","visible":true,"id":"","linkType":"url","targetDialogId":""}]}
        sectionId={"section-footer"}
      />
      <FullBody
        image={"https://assets.ramenyes.com/bg_desktop.webp"}
        mobileImage={"https://assets.ramenyes.com/bg_full_mobile.webp"}
        sectionId={"background"}
      />
      </StickyManager>
      </div>
      <Notification />
    </main>
  );
}
